import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/* Loading skeletons (Phase 5) — quiet placeholders instead of spinners so
 * pages keep their shape while data arrives. */

export const CardSkeleton = ({ lines = 3, testid = "card-skeleton" }) => (
    <div className="ml-card p-6 bg-white space-y-3" data-testid={testid} aria-hidden="true">
        <Skeleton className="h-5 w-2/5 bg-cream-dark/60" />
        {Array.from({ length: lines }).map((_, i) => (
            <Skeleton key={i} className={`h-4 bg-cream-dark/40 ${i % 2 ? "w-4/5" : "w-full"}`} />
        ))}
    </div>
);

export const PageSkeleton = ({ cards = 3, testid = "page-skeleton" }) => (
    <div className="space-y-5 animate-fade-in-up" data-testid={testid} role="status" aria-label="Loading">
        <div className="space-y-2">
            <Skeleton className="h-4 w-24 bg-cream-dark/50" />
            <Skeleton className="h-8 w-3/5 bg-cream-dark/60" />
            <Skeleton className="h-4 w-2/5 bg-cream-dark/40" />
        </div>
        {Array.from({ length: cards }).map((_, i) => (
            <CardSkeleton key={i} lines={3} testid={`${testid}-card-${i}`} />
        ))}
        <span className="sr-only">Loading…</span>
    </div>
);

export default PageSkeleton;
